import { useState, useEffect } from 'react';
import ApiService from 'services/api';
import { Spin } from 'antd';

import { CurrentConversationStore } from 'stores/current-conversation';

import { ReactComponent as WebIcon } from './web.svg';
import { ReactComponent as DocumentIcon } from './file.svg';

const fileTypes = ['.pdf', '.ppt', '.pptx', '.doc', '.docx', '.txt'];
function isFileType(displayName) {
  return fileTypes.some((fileType) => displayName.endsWith(fileType));
}

function getOriginTypeIcon(displayName) {
  if (!isFileType(displayName)) {
    return <WebIcon data-testid="source-icon" />;
  }

  return <DocumentIcon data-testid="source-icon" />;
}

async function getSourceHrefValue({ messageId, conversationId, source }) {
  try {
    const signedUrls = await ApiService.getSignedSources({
      messageId,
      conversationId,
      source,
    });
    return signedUrls || [];
  } catch (error) {
    return false;
  }
}

const SourceItem = ({ source, messageId }) => {
  const [url, setUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const conversationId = CurrentConversationStore.useState((s) => s.id);

  useEffect(() => {
    const fetchSignedUrl = async () => {
      setIsLoading(true);
      const hrefValue = await getSourceHrefValue({
        messageId,
        conversationId,
        source,
      });
      setUrl(hrefValue?.url);
      setIsLoading(false);
    };

    fetchSignedUrl();
  }, [source, messageId, conversationId]);

  return (
    <div className="source-item" data-testid="source-item">
      {isLoading ? (
        <Spin size="small" />
      ) : (
        getOriginTypeIcon(source.displayName)
      )}
      <div>
        {isLoading ? (
          <span>{source.displayName}</span>
        ) : url ? (
          <a href={url} target="_blank" rel="noreferrer">
            {source.displayName}
          </a>
        ) : (
          <span>{source.displayName}</span>
        )}
      </div>
    </div>
  );
};

export default SourceItem;
